module.exports = __webpack_public_path__ + "static/media/support.82008fcf.svg";